import React, { Component } from 'react';


class LiveChat extends Component {

  componentDidMount() {
    window.liveChat('init', 'cc722472-0341-4537-885a-c383a329b9c5');
  }

  render() {
    return (
      <div>
      </div>
    );
  }
}

export default LiveChat;


export const INITLIVECHAT = () => {
  window.LiveChat = window.LiveChat || function() {};
  window.addEventListener('load', () => {
    (function(I,n,f,o,b,i,p) {
      I[b] =
        I[b] ||
        function() {
          (I[b].q=I[b].q||[]).push(arguments);
        };
      I[b].t=1*new Date();
      i=n.createElement(f);
      i.async=1;
      i.src=o;
      p=n.getElementsByTagName(f)[0];
      p.parentNode.insertBefore(i,p)      
    })(window,document,'script','https://livechat.infobip.com/widget.js','liveChat');
  });
};

export const openLiveChat = () => window.LiveChat('init', 'cc722472-0341-4537-885a-c383a329b9c5');



// WEBPACK FOOTER //
// ./src/components/LiveChat.js